import React, { useMemo, useState } from 'react';
import { createContext } from 'react';
import { CommentResolutionType } from '@cube3/common/model/schema/resources/comment';

interface ReviewCommentsFilterType {
  filter: CommentResolutionType | 'all';
  setFilter: (filter: CommentResolutionType | 'all') => void;
}

export const ReviewCommentsFilterContext =
  createContext<ReviewCommentsFilterType>(null);

export const ReviewCommentsFilterProvider = (props) => {
  const [filter, setFilter] = useState<CommentResolutionType | 'all'>(
    'unresolve'
  );
  const context = useMemo(
    () => ({ filter, setFilter }),
    [{ filter, setFilter }]
  );

  return (
    <ReviewCommentsFilterContext.Provider value={context}>
      {props.children}
    </ReviewCommentsFilterContext.Provider>
  );
};
